import { io } from "socket.io-client";
import { SOCKET_EVENTS } from "../utils/constants";

const socket = io("", {
  path: "/api/socket.io/"
});

/**
 * @desc A HOF which listens to a socket and executes an event
 * callback.
 */
export const createSocketListener = (eventCallback) => (callback, props) => {
  const event = eventCallback(props);
  socket.off(event);
  socket.on(event, (res) => {
    callback(res);
  });
};

/**
 * @param {function} callback
 * @param {string} conventionId
 */
export const listenToProductUpdates = createSocketListener(
  SOCKET_EVENTS.LIVE_PRODUCTS_UPDATE
);

/**
 * @param {function} callback
 * @param {string} brand
 */
export const listenToConventionUpdates = createSocketListener(
  SOCKET_EVENTS.LIVE_CONVENTION_UPDATE
);

/**
 * @param {function} callback
 * @param {string} brand
 */
export const listenToPublishConvention = createSocketListener(
  SOCKET_EVENTS.PUBLISH_CONVENTION
);

/**
 * @param {function} callback
 * @param {string} brand
 */
export const listenToUnpublishConvention = createSocketListener(
  SOCKET_EVENTS.UNPUBLISH_CONVENTION
);
